/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class ObjectsApi extends runtime.BaseAPI {
    /**
     * Get an automatically selected blob that matches the query
     */
    async objectsObjectIdBlobsAutoGetRaw(requestParameters, initOverrides) {
        if (requestParameters.objectId === null ||
            requestParameters.objectId === undefined) {
            throw new runtime.RequiredError('objectId', 'Required parameter requestParameters.objectId was null or undefined when calling objectsObjectIdBlobsAutoGet.');
        }
        const queryParameters = {};
        if (requestParameters.fetchFormat !== undefined) {
            queryParameters['fetchFormat'] = requestParameters.fetchFormat;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/objects/{objectId}/blobs/$auto`.replace(`{${'objectId'}}`, String(requestParameters.objectId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an automatically selected blob that matches the query
     */
    async objectsObjectIdBlobsAutoGet(requestParameters, initOverrides) {
        const response = await this.objectsObjectIdBlobsAutoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get content object details.
     */
    async objectsObjectIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.objectId === null ||
            requestParameters.objectId === undefined) {
            throw new runtime.RequiredError('objectId', 'Required parameter requestParameters.objectId was null or undefined when calling objectsObjectIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/objects/{objectId}`.replace(`{${'objectId'}}`, String(requestParameters.objectId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get content object details.
     */
    async objectsObjectIdGet(requestParameters, initOverrides) {
        const response = await this.objectsObjectIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=ObjectsApi.js.map